import { ADD, ADD_MULTIPLE, REMOVE } from './constants';
import DonationSchedule from './model';
import { DonationScheduleMap } from './reducer';

export const addAction = (donationSchedule: DonationSchedule) => ({
  type: ADD,
  donationSchedule,
});

export const addMultipleAction = (donationSchedules: DonationScheduleMap) => ({
  type: ADD_MULTIPLE,
  donationSchedules,
});

export const removeAction = (id: string) => ({
  type: REMOVE,
  id,
});
